// extracted by mini-css-extract-plugin
module.exports = {"notes":"notes_3I7VD","icon":"icon_2q49G","notesDetails":"notesDetails_37iLC","botDetails":"botDetails_3HMLX"};